/* NEOLAB product.js
   商品詳細ページ: ギャラリー切替 / バリアント選択（価格・在庫更新）/ 数量± /
   カート追加(fetch) / アコーディオン / レビューモーダル */
(function () {
  'use strict';

  function $$(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  /* ---------- ギャラリー ---------- */
  function initGallery(root) {
    var images = $$(root, '[data-gallery-image]');
    var thumbs = $$(root, '[data-gallery-thumb]');
    if (!images.length) return null;

    function activate(index) {
      images.forEach(function (img) {
        img.classList.toggle('is-active', Number(img.dataset.mediaIndex) === index);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.dataset.mediaIndex) === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(Number(thumb.dataset.mediaIndex));
      });
    });

    return activate;
  }

  /* ---------- バリアント選択 ---------- */
  function initVariants(root, galleryActivate) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return null;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return null;
    }

    var radios = $$(root, '[data-option-input]');
    if (!radios.length) return null;

    var idInput = root.querySelector('[data-variant-id]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var priceChip = root.querySelector('[data-price-chip]');
    var addButton = root.querySelector('[data-add-button]');
    var addText = root.querySelector('[data-add-text]');

    function selectedOptions() {
      var options = [];
      radios.forEach(function (radio) {
        if (radio.checked) {
          options[Number(radio.dataset.optionPosition) - 1] = radio.value;
        }
      });
      return options;
    }

    function findVariant(options) {
      var key = options.join('|||');
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.join('|||') === key) return variants[i];
      }
      return null;
    }

    function updateSelectedLabels() {
      $$(root, '[data-selected-value]').forEach(function (label) {
        var position = Number(label.dataset.optionPosition);
        radios.forEach(function (radio) {
          if (radio.checked && Number(radio.dataset.optionPosition) === position) {
            label.textContent = radio.value;
          }
        });
      });
    }

    /* 現在選択中のバリアントで購入ボタンの有効/文言を再評価する（busy中はスキップ） */
    function refreshButton() {
      if (!addButton || !addText || addButton.dataset.busy) return;
      var variant = findVariant(selectedOptions());
      if (!variant) {
        addButton.disabled = true;
        addText.textContent = 'この組み合わせは選択できません';
        return;
      }
      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? 'カートに入れる' : '売り切れ';
    }

    function update() {
      updateSelectedLabels();
      var variant = findVariant(selectedOptions());
      refreshButton();

      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceCurrent) {
        priceCurrent.textContent = variant.price;
        priceCurrent.classList.toggle('is-sale', Boolean(variant.compare_at_price));
      }
      if (priceCompare) {
        priceCompare.textContent = variant.compare_at_price || '';
        priceCompare.classList.toggle('is-hidden', !variant.compare_at_price);
      }
      if (priceChip) {
        priceChip.textContent = variant.discount ? variant.discount + '%OFF' : '';
        priceChip.classList.toggle('is-hidden', !variant.discount);
      }

      if (variant.media_index !== null && typeof galleryActivate === 'function') {
        galleryActivate(variant.media_index);
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', update);
    });

    return refreshButton;
  }

  /* ---------- 数量± ---------- */
  function initQuantity(root) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');

    function clamp(value) {
      value = parseInt(value, 10);
      if (isNaN(value) || value < 1) return 1;
      return value;
    }

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = clamp(Number(input.value) - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = clamp(Number(input.value) + 1);
      });
    }
    input.addEventListener('change', function () {
      input.value = clamp(input.value);
    });
  }

  /* ---------- カート追加（fetch + 簡易フィードバック） ---------- */
  function initAddToCart(root, refreshButton) {
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var button = root.querySelector('[data-add-button]');
    var text = root.querySelector('[data-add-text]');
    var feedback = root.querySelector('[data-cart-feedback]');
    var feedbackText = root.querySelector('[data-cart-feedback-text]');
    var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    function refreshCartCount() {
      return fetch(routeRoot + 'cart.js')
        .then(function (response) {
          if (!response.ok) throw new Error('cart unavailable');
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.setAttribute('data-cart-count', cart.item_count);
          });
          document.querySelectorAll('[data-cart-link]').forEach(function (el) {
            el.setAttribute('aria-label', 'カート（' + cart.item_count + '点）');
          });
        })
        .catch(function () {});
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!button || button.disabled) return;

      button.dataset.busy = 'true';
      button.disabled = true;
      if (text) text.textContent = '追加しています…';
      if (feedback) feedback.hidden = true;

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (result) {
            if (!response.ok) {
              var failure = new Error('add-to-cart failed');
              failure.userMessage = typeof result.description === 'string' ? result.description : '';
              throw failure;
            }
            return result;
          });
        })
        .then(function () {
          if (text) text.textContent = 'カートに追加しました';
        })
        .catch(function (error) {
          if (text) text.textContent = '追加できませんでした';
          if (feedback && feedbackText) {
            feedbackText.textContent = error.userMessage || feedback.dataset.errorMessage;
            feedback.hidden = false;
          }
        })
        .then(refreshCartCount)
        .then(function () {
          window.setTimeout(function () {
            delete button.dataset.busy;
            if (typeof refreshButton === 'function') {
              /* 追加処理中に売り切れバリアントへ切り替えた場合に備え、現在の選択で再評価 */
              refreshButton();
            } else {
              button.disabled = false;
              if (text) text.textContent = 'カートに入れる';
            }
          }, 1800);
        });
    });
  }

  /* ---------- アコーディオン（details/summary の開閉アニメーション） ---------- */
  function initAccordions(root) {
    $$(root, '[data-accordion]').forEach(function (details) {
      var summary = details.querySelector('summary');
      var body = details.querySelector('[data-accordion-body]');
      if (!summary || !body) return;

      var animating = false;

      function settle(callback) {
        var called = false;
        function run() {
          if (called) return;
          called = true;
          callback();
        }
        body.addEventListener('transitionend', function handler(event) {
          if (event.target !== body) return;
          body.removeEventListener('transitionend', handler);
          run();
        });
        window.setTimeout(run, 400); /* transition未発火時の保険 */
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (animating) return;
        animating = true;

        if (details.open) {
          body.style.maxHeight = body.scrollHeight + 'px';
          window.requestAnimationFrame(function () {
            body.style.maxHeight = '0px';
          });
          settle(function () {
            details.open = false;
            body.style.maxHeight = '';
            animating = false;
          });
        } else {
          details.open = true;
          var target = body.scrollHeight;
          body.style.maxHeight = '0px';
          window.requestAnimationFrame(function () {
            body.style.maxHeight = target + 'px';
          });
          settle(function () {
            body.style.maxHeight = '';
            animating = false;
          });
        }
      });
    });
  }

  /* ---------- レビューモーダル ---------- */
  function initReviewModal(root) {
    var modal = root.querySelector('[data-review-modal]');
    if (!modal) return;

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    function open() {
      modal.hidden = false;
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        modal.hidden = true;
      }, 220);
    }

    $$(root, '[data-review-modal-open]').forEach(function (opener) {
      opener.addEventListener('click', open);
    });
    $$(modal, '[data-review-modal-close]').forEach(function (closer) {
      closer.addEventListener('click', close);
    });

    /* 並び替え（新しい順/古い順）＋初期整列＋表示件数の再計算 */
    var sort = modal.querySelector('[data-review-sort]');
    var list = modal.querySelector('[data-review-list]');
    var more = modal.querySelector('[data-review-more]');
    var VISIBLE = 4; /* 初期表示件数（Liquid側 index>4 と一致） */
    var expanded = false;

    function sortCards(order) {
      var cards = $$(list, '[data-review-card]');
      cards.sort(function (a, b) {
        var dateA = Date.parse(a.dataset.date || '') || 0;
        var dateB = Date.parse(b.dataset.date || '') || 0;
        return order === 'old' ? dateA - dateB : dateB - dateA;
      });
      cards.forEach(function (card) { list.appendChild(card); });
    }

    function applyVisibility() {
      var cards = $$(list, '[data-review-card]');
      cards.forEach(function (card, i) {
        card.classList.toggle('is-hidden', !expanded && i >= VISIBLE);
      });
      if (more && more.parentElement) {
        more.parentElement.style.display = (expanded || cards.length <= VISIBLE) ? 'none' : '';
      }
    }

    if (list) {
      /* 既定は「新しい順」。入稿順に依存せず、開いた時点で並び順ラベルと一致させる */
      sortCards(sort ? sort.value : 'new');
      applyVisibility();
    }
    if (sort && list) {
      sort.addEventListener('change', function () {
        sortCards(sort.value);
        applyVisibility();
      });
    }

    /* もっと見る */
    if (more && list) {
      more.addEventListener('click', function () {
        expanded = true;
        applyVisibility();
      });
    }
  }

  /* ---------- ハート（お気に入り・見た目のみ） ---------- */
  function initHeart(root) {
    $$(root, '[data-heart]').forEach(function (button) {
      button.addEventListener('click', function () {
        var active = button.classList.toggle('is-active');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  /* ---------- 初期化 ---------- */
  /* ---------- カート追尾バー（No.35）: 購入エリアが画面上に消えたら表示 ---------- */
  function initStickyBar(root) {
    var bar = root.querySelector('[data-sticky-bar]');
    var mainAdd = root.querySelector('[name="add"]');
    if (!bar || !mainAdd || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }, { threshold: 0 });
    observer.observe(mainAdd);

    // 追尾バーのボタン→本体のカートボタンを代理クリック
    var stickyAdd = bar.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () { mainAdd.click(); });
    }
    // バリアント切替に価格・在庫表示を同期
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var stickyText = bar.querySelector('[data-sticky-add-text]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var mainText = root.querySelector('[data-add-text]');
    var sync = function () {
      if (stickyPrice && priceCurrent) stickyPrice.innerHTML = priceCurrent.textContent + '<span>（税込）</span>';
      if (stickyText && mainText) stickyText.textContent = mainText.textContent;
      if (stickyAdd) stickyAdd.disabled = mainAdd.disabled;
    };
    sync();
    var stateObserver = new MutationObserver(sync);
    stateObserver.observe(mainAdd, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
    if (priceCurrent) stateObserver.observe(priceCurrent, { childList: true, subtree: true });
    root.addEventListener('change', function () { window.setTimeout(sync, 0); });
  }

  function init() {
    document.querySelectorAll('[data-main-product]').forEach(function (root) {
      if (root.dataset.productInit === 'true') return;
      root.dataset.productInit = 'true';

      var galleryActivate = initGallery(root);
      var refreshButton = initVariants(root, galleryActivate);
      initQuantity(root);
      initAddToCart(root, refreshButton);
      initAccordions(root);
      initReviewModal(root);
      initHeart(root);
      initStickyBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
